/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IamUserRole
 */
export interface IamUserRole {
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamUserRole
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamUserRole
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    orgId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserRole
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamUserRole
     */
    statusDate?: Date;
}

export function IamUserRoleFromJSON(json: any): IamUserRole {
    return IamUserRoleFromJSONTyped(json, false);
}

export function IamUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): IamUserRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'orgId': !exists(json, 'org_id') ? undefined : json['org_id'],
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'roleId': !exists(json, 'role_id') ? undefined : json['role_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
    };
}

export function IamUserRoleToJSON(value?: IamUserRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'org_id': value.orgId,
        'user_id': value.userId,
        'role_id': value.roleId,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
    };
}


